//Exam
const REFRESH_TOKEN = "/auth/refreshtoken";

export const auth = {
  REFRESH_TOKEN,
};
